export const SECTORS = [
  "Ristorazione",
  "Hotellerie e ospitalità",
  "Automotive",
  "Gioielleria",
  "Cantieristica navale",
  "Luxury boat tour ed esperienze turistiche",
  "Edilizia e ristrutturazioni",
  "Studi di yoga e pilates",
  "Benessere e discipline olistiche",
  "Formazione regionale",
];

export const SECTOR_TAGS = [
  "Ristorazione",
  "Hotellerie",
  "Automotive",
  "Gioielleria",
  "Cantieristica navale",
  "Luxury boat tour",
  "Ristrutturazioni",
  "Yoga & Pilates",
  "Benessere olistico",
  "Formazione regionale",
];

export const AREAS = [
  "Napoli",
  "Salerno",
  "Caserta",
  "Avellino",
  "Benevento",
  "Tutta Italia",
];

export const CLIENTS = [
  {
    name: "Barbara Positano Luxury Boat Tours",
    sector: "Luxury boat tour · Costiera Amalfitana",
    url: "https://www.barbarapositano.it",
    note: "Esperienze private in barca tra Positano, Amalfi e Capri.",
  },
  {
    name: "Ristruttura Plus",
    sector: "Edilizia e ristrutturazioni · Castellammare di Stabia (NA)",
    url: "https://ristrutturaplus.it",
    note: "Progettazione, ristrutturazioni chiavi in mano e pratiche per bonus edilizi.",
  },
  {
    name: "Gusto Verace",
    sector: "Ristorazione · Campania",
    url: null,
    note: "Cucina campana e format di ristorazione.",
  },
  {
    name: "Breathe Yoga Studios",
    sector: "Yoga e pilates · Campania",
    url: "https://www.instagram.com/breathe_yogastudios/",
    note: "Studi di yoga e pilates con percorsi per tutti i livelli.",
  },
];
